import Vue from 'vue'

const GlobalMixinsCtx = require.context('../mixins/_globals', true, /\.js$/)
GlobalMixinsCtx.keys().forEach(_mixin => {
  const mixin = GlobalMixinsCtx(_mixin)
  Vue.mixin(mixin.default)
})
